import Glide from '@glidejs/glide';

let glide = new Glide('.glide-quotes', {
  type: 'carousel',
  perView: 1,
  focusAt: 'center',
  gap: 24,
});
glide.mount();